module.exports = __webpack_public_path__ + "static/media/striped_bar_M1_tall.44ee2f9a.svg";